module.exports = __webpack_public_path__ + "img/loader.a3c888f2.svg";